// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnShare_btn__1Ph3l","btnShare":"BtnShare_btnShare__2-nfc BtnShare_btn__1Ph3l"};